import React from 'react';
import WbModal from '@sonifi/wb-widget/components/WbModal/WbModal';
import styles from './WbIdle.module.css';

const WbIdleModal = ({ open, onCancel, remainingTime }) => {
  const seconds = remainingTime > 1 ? 'seconds' : 'second';
  return (
    <WbModal show={open}>
      <div className={styles.modalContainer}>
        <h1 className={styles.modalTitle}>You will be logged out</h1>
        <p>{`in ${remainingTime} ${seconds}`}</p>
        <button onClick={onCancel}>Cancel Logout</button>
      </div>
    </WbModal>
  );
};

export default WbIdleModal;
